// ข้อมูลจำลองจาก mockups/console.html (approved) — ใช้ตอนยังไม่ตั้ง IB_SUPABASE_URL
// โครง shape เดียวกับที่ data layer ฝั่ง live จะ map ให้ (shipment → consignments → docs)
// k = category: money | ship | origin | permit | customs | wh
// s = status:   ok | f (flagged) | m (missing) | na

export const SHIPMENTS = [
  {
    id: 'SHP-2607', mode: 'sea', route: 'JP + US → แหลมฉบัง', eta: 'ETA 4 วัน',
    phase: 'Docs & Form', urgency: 'urgent', why: 'CO ยังไม่มา + free time เหลือ 4 วัน',
    pct: 70,
    alert: 'Free time เหลือ 4 วัน ก่อนเสีย storage ฿1,500/วัน — ต้องได้ Form JTEPA ก่อนของถึง',
    next: 'ตาม Form JTEPA จาก Snow Peak — ร่างข้อความทวงไว้แล้ว',
    consignments: [
      { kind: 'Consignment A', nm: 'Snow Peak', hue: '#8b5cf6', origin: 'Japan', pos: 'PO-1021 · PO-1022', docs: [
        { t: 'Proforma Invoice', k: 'money', s: 'ok', f: 'pi_snowpeak.pdf' },
        { t: 'Commercial Invoice', k: 'money', s: 'ok', f: 'inv_sp_0621.pdf' },
        { t: 'Packing List', k: 'ship', s: 'ok', f: 'pl_sp_0621.pdf' },
        { t: 'Bill of Lading', k: 'ship', s: 'ok', f: 'bl_ONEY0521.pdf' },
        { t: 'Form JTEPA', k: 'origin', s: 'm', urgent: true, note: 'ต้องได้ก่อนของถึง' },
        { t: 'Product Dossier', k: 'customs', s: 'ok', f: 'sku ครบ 8/8' },
        { t: 'Phytosanitary Cert', k: 'permit', s: 'ok', f: 'phyto_JP_0621.pdf', side: 'exp' },
        { t: 'ใบอนุญาตกรมป่าไม้', k: 'permit', s: 'm', note: 'ยื่นก่อน clear (มีของไม้)', side: 'imp' },
      ] },
      { kind: 'Consignment B', nm: 'Nalgene', hue: '#2f6bff', origin: 'USA', pos: 'PO-1030', docs: [
        { t: 'Proforma Invoice', k: 'money', s: 'ok', f: 'pi_nalgene.pdf' },
        { t: 'Commercial Invoice', k: 'money', s: 'ok', f: 'inv_ng_4471.pdf' },
        { t: 'Packing List', k: 'ship', s: 'f', note: 'qty ↔ PO ไม่ตรง (−2)' },
        { t: 'Bill of Lading', k: 'ship', s: 'ok', f: 'bl_ONEY0521.pdf' },
        { t: 'Certificate of Origin', k: 'origin', s: 'na', note: 'US ไม่มี FTA form' },
        { t: 'Product Dossier', k: 'customs', s: 'm', note: 'SKU ใหม่ 3 ตัว' },
      ] },
    ],
    shipmentDocs: { kind: 'Shipment', nm: 'ระดับตู้ / พิธีการ', hue: '#ff5470', meta: 'self-clear = broker', docs: [
      { t: 'Booking Confirmation', k: 'ship', s: 'ok', f: 'bkg_2607.pdf' },
      { t: 'ใบขนขาเข้า', k: 'customs', s: 'm', note: 'รอ CO ครบก่อนส่ง broker' },
      { t: 'ใบเสร็จอากร / VAT', k: 'customs', s: 'm' },
      { t: 'ใบตรวจรับเข้าคลัง', k: 'wh', s: 'm' },
    ] },
    tray: { name: 'inv_snowpeak_v2.pdf', to: 'Snow Peak · Commercial Invoice' },
  },
  {
    id: 'SHP-2611', label: 'Snow Peak · เติมสต๊อก', mode: 'air', route: 'JP → สุวรรณภูมิ', eta: 'ETA 2 วัน',
    phase: 'Customs', urgency: 'watch', why: 'เกือบครบ รอใบขน (ทำตอนของถึง)',
    pct: 90, alert: null,
    next: 'ตรวจใบขน HS line 4 กับ broker ก่อนชำระอากร',
    consignments: [
      { kind: 'Consignment', nm: 'Snow Peak', hue: '#8b5cf6', origin: 'Japan', pos: 'PO-1045', docs: [
        { t: 'Proforma Invoice', k: 'money', s: 'ok', f: 'pi_sp_1045.pdf' },
        { t: 'Commercial Invoice', k: 'money', s: 'ok', f: 'inv_sp_0705.pdf' },
        { t: 'Packing List', k: 'ship', s: 'ok', f: 'pl_sp_0705.pdf' },
        { t: 'Air Waybill', k: 'ship', s: 'ok', f: 'awb_618-33.pdf' },
        { t: 'Form JTEPA', k: 'origin', s: 'ok', f: 'jtepa_1045.pdf' },
        { t: 'Product Dossier', k: 'customs', s: 'ok', f: 'sku ครบ 5/5' },
      ] },
    ],
    shipmentDocs: { kind: 'Shipment', nm: 'ระดับตู้ / พิธีการ', hue: '#ff5470', meta: 'broker: TKL', docs: [
      { t: 'Booking Confirmation', k: 'ship', s: 'ok', f: 'bkg_2611.pdf' },
      { t: 'ใบขนขาเข้า', k: 'customs', s: 'f', note: 'ตรวจพิกัด HS line 4' },
      { t: 'ใบเสร็จอากร / VAT', k: 'customs', s: 'm' },
      { t: 'ใบตรวจรับเข้าคลัง', k: 'wh', s: 'm' },
    ] },
    tray: null,
  },
  {
    id: 'SHP-2615', mode: 'sea', route: 'US → แหลมฉบัง', eta: 'ETA 21 วัน',
    phase: 'Order & Pay', urgency: 'ok', why: 'ยังเร็ว กำลังรวบรวมเอกสาร',
    pct: 38, alert: null,
    next: 'ส่งสลิปโอนให้ Nalgene รอ confirm รับเงิน',
    consignments: [
      { kind: 'Consignment', nm: 'Nalgene', hue: '#2f6bff', origin: 'USA', pos: 'PO-1052 · PO-1053', docs: [
        { t: 'Proforma Invoice', k: 'money', s: 'ok', f: 'pi_ng_1052.pdf' },
        { t: 'หลักฐานโอน / SWIFT', k: 'money', s: 'f', note: 'รอบัญชียืนยันโอน' },
        { t: 'Commercial Invoice', k: 'money', s: 'm' },
        { t: 'Packing List', k: 'ship', s: 'm' },
        { t: 'Bill of Lading', k: 'ship', s: 'm' },
        { t: 'Certificate of Origin', k: 'origin', s: 'na', note: 'US ไม่มี FTA form' },
        { t: 'Product Dossier', k: 'customs', s: 'm', note: 'SKU ใหม่ 6 ตัว — ต้องได้ก่อนส่ง broker' },
      ] },
    ],
    shipmentDocs: { kind: 'Shipment', nm: 'ระดับตู้ / พิธีการ', hue: '#ff5470', meta: 'ยังไม่กำหนด', docs: [
      { t: 'Booking Confirmation', k: 'ship', s: 'm' },
      { t: 'ใบขนขาเข้า', k: 'customs', s: 'm' },
      { t: 'ใบเสร็จอากร / VAT', k: 'customs', s: 'm' },
      { t: 'ใบตรวจรับเข้าคลัง', k: 'wh', s: 'm' },
    ] },
    tray: null,
  },
];

export const shipName = s => s.label || [...new Set(s.consignments.map(c => c.nm))].join(' · ');
